import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';
import type { ClinicTypeInterface } from '../models/clinic-type.interface';

@Injectable()
export class ClinicTypeService {
  constructor(private readonly apollo: Apollo) { }

  getClinicTypes(): Observable<ClinicTypeInterface[]> {
    return this.apollo.query<GetClinicsReponse>({
      query : gql`query adminGetClinicTypes {
        clinicTypes(order: { label: ASC }) {
          id
          label
          shortLabel
        }
      }`
    }).pipe(map(res => res.data.clinicTypes));
  }
}

export interface GetClinicsReponse {
  clinicTypes: ClinicTypeInterface[];
}
